import * as actions from "../actionTypes";
import httpClient from "../../utils/HttpClient";
import { server } from "../../utils/Constants";
import Actions from "../actions";
import { call, put, delay } from "redux-saga/effects";

export function* sagaGetCar() {
  try {
    yield put(Actions.getCarFetching());

    const response = yield call(httpClient.get, server.CAR);

    if (response.status == 200) {
      yield put(Actions.getCarSuccess(response.data.data));
    }
  } catch (error) {
    yield put(Actions.getCarFailed());
  }
}
